export default __webpack_public_path__ + "static/media/logo.aa3b185b.png";